import { useState, useEffect } from 'react';
import { useFetch } from 'react-async';
// import uuid from 'uuid/v1';
import config from '../config';

const headers = { Accept: "application/json" }

export function useProduct(productHandle) {
     /* Will contain our product data */
     const [product, setProduct] = useState(null);

     // /* Check local storage if we have any user Id */
     // let userId = window.localStorage.getItem( 'userId' );

     // /* If we don't have a user id */
     // if ( !userId ) {
     //      /* Generate a new one */
     //      userId = uuid();

     //      /* Store it */
     //      window.localStorage.setItem( 'userId', userId );
     // }

     /* Read the URL see if there is a selected color Id */
     var queryParams = (new URL(document.location)).searchParams;
     var colorId = queryParams.get("colorId");
     var collection = queryParams.get("collection");
     var filter = queryParams.get("filter");

     const url = `${config.backendUrl}/shopify-store/${config.storeId}`

     /* Fetch the product using product Id, passing through the userId */
     const fetch = useFetch(`${url}/products/${productHandle}?colorId=${colorId}&collection=${collection}${filter ? `&filter=${filter}` : ''}`, { headers }, { json: true });

     useEffect(() => {
          if (fetch.data && fetch.data.products) {
               setProduct({ ...fetch.data, ...fetch.data.products[0] });
          }
     }, [fetch.data]);

     return {
          ...fetch,
          product,
     }
}
